<template>
	<section id='intro' :class="{ ddd }">
		<a href="/dozywotnia-gwarancja">
			<span id="city" > </span>
		</a>

		<!--    <div class="section-main-raty" v-if="is_pl">-->
		<!--      <p class="left"><a href="/raty">WAKACJE BEZ RAT!</a></p>-->
		<!--      <p class="right">-->
		<!--        <a href="/raty">Kup rower <strong>le grand</strong> teraz, <br/>zapłać po wakacjach!</a>-->
		<!--      </p>-->
		<!--    </div>-->
		<div class="container center padded">

			<h1 class="color-mint" v-translate="'pg_intro_hd'">Ruszaj w miasto</h1>
			<p v-translate="'pg_intro'">Mieszkasz w wielkim mieście. Albo mieszkasz w mniejszym mieście. Pracujesz,
				studiujesz,
				albo spędzasz czas tak, jak masz ochotę. Więc kiedy tylko chcesz, ruszasz w miasto na swoim klasycznym
				rowerze Le Grand
				i jedziesz tam, gdzie chcesz. Możesz mieć pewność, że będzie stylowo i wygodnie, uśmiech sam pojawi się
				na Twojej twarzy i na twarzach ludzi, których będziesz mijać. I będzie pięknie. Ot tak, po prostu.</p>
		</div>
	</section>
</template>
<script>
	export default {
		name: 'HomePageIntro',
		data() {
			return {
				ddd: false,
				is_pl: env.language === 'pl'
			}
		},
		mounted() {
			// czy mamy daty akcji dzień darmowej dostawy
			if (typeof window.ddd !== "undefined") {
				let now = new Date();
				this.ddd = (now > window.ddd.start && now < window.ddd.end );
			}
		},
		methods: {
			t: function (text) {
				return translations[text];
			},
			getCityClass() {
				let lang = 'pl';
				if (typeof window.language !== 'undefined') {
					lang = window.lang;
				}
				return "city-" + lang;
			}
		},

	}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/Intro.vue